/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';

function defineBlock(context) {
    return {
        init: function () {
            let selectRepeaterDropdown = new Blockly.FieldWidgetsDropdown(context, 'repeater', undefined, '- select -');

            this.appendDummyInput('WIDGET')
                .appendField("get current entry index for")
                .appendField(selectRepeaterDropdown, "ID");

            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, "Number");
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Get index of current entry for repeater widget.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#repeater`);
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let repeaterId = block.getFieldValue('ID');
            let code = `Snap.widgets.repeater.getCurrentEntryIndex("${repeaterId}")`;
            return [code, Blockly.JavaScript.ORDER_NONE];
        }
    }
}

const RepeaterEntryIndex = function (props) {
    const name = 'snap_repeater_entry_index';
    RepeaterEntryIndex.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

RepeaterEntryIndex.propTypes = {
    context: PropTypes.object.isRequired,
};

export default RepeaterEntryIndex;
